export const getImageThumbBase64 = (file) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file)
  const img = new Image()

  img.onerror = (err) => {
    URL.revokeObjectURL(url)
    reject(err)
  }

  img.onload = () => {
    const width = img.naturalWidth
    const height = img.naturalHeight

    // Keep aspect ratio, never upscale
    const maxSize = 16
    const scale = Math.min(1, maxSize / width, maxSize / height)
    const targetW = Math.round(width * scale)
    const targetH = Math.round(height * scale)

    const canvas = document.createElement('canvas')
    canvas.width = targetW
    canvas.height = targetH
    const ctx = canvas.getContext('2d')

    // Ensure white background (for images with transparency)
    ctx.fillStyle = '#fff'
    ctx.fillRect(0, 0, targetW, targetH)

    ctx.drawImage(img, 0, 0, targetW, targetH)
    const base64 = canvas.toDataURL('image/jpeg', 0.5)

    URL.revokeObjectURL(url)

    resolve({
      width,
      height,
      base64,
    })
  }

  img.src = url
})
